import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { ListActionsLayout } from "./list-actions-layout";
var getEmptyItem = function getEmptyItem() {
  return {
    id: crypto.randomUUID(),
    value: undefined
  };
};
export function useListManager(_ref) {
  var _ref$maxItems = _ref.maxItems,
    maxItems = _ref$maxItems === void 0 ? 5 : _ref$maxItems,
    onChange = _ref.onChange,
    _ref$defaultValues = _ref.defaultValues,
    defaultValues = _ref$defaultValues === void 0 ? [] : _ref$defaultValues;
  var _useState = useState(function () {
      if (defaultValues.length === 0) {
        return [getEmptyItem()];
      }
      return defaultValues.map(function (value) {
        return {
          id: crypto.randomUUID(),
          value: value
        };
      });
    }),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  function handleItemChange(value, index) {
    setItems(function (prevItems) {
      var newItems = _toConsumableArray(prevItems);
      newItems[index] = _objectSpread(_objectSpread({}, newItems[index]), {}, {
        value: value
      });
      var validValues = newItems.map(function (item) {
        return item.value;
      }).filter(Boolean);
      onChange === null || onChange === void 0 ? void 0 : onChange(validValues);
      return newItems;
    });
  }
  function handleAddItem() {
    if (items.length >= maxItems) {
      return;
    }
    setItems(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        id: crypto.randomUUID(),
        value: undefined
      }]);
    });
  }
  function handleDeleteItem(index) {
    setItems(function (prevItems) {
      var newItems = prevItems.filter(function (_, idx) {
        return idx !== index;
      });
      // If we deleted the last item and there are no items left, create a fresh empty item with new reference
      if (newItems.length === 0) {
        return [getEmptyItem()];
      }

      // Update onChange with the new valid values
      var validValues = newItems.map(function (item) {
        return item.value;
      }).filter(Boolean);
      onChange === null || onChange === void 0 ? void 0 : onChange(validValues);
      return newItems;
    });
  }
  function handleDeleteAll() {
    setItems([getEmptyItem()]);
    onChange === null || onChange === void 0 ? void 0 : onChange([]);
  }
  return [ListActionsLayout, {
    items: items,
    canAdd: items.length < maxItems,
    canDeleteAll: !(items.length === 1 && !items[0].value),
    onItemChange: handleItemChange,
    onAddItem: handleAddItem,
    onDeleteItem: handleDeleteItem,
    onDeleteAll: handleDeleteAll
  }];
}